// Modál „Uložit filtr k produktu“ — vybere se 1+ produktů (napříč skupinami GROUP_PRODUCTS),
// filtr se uloží ke každému zvolenému. Defaultně zatržený jen aktuálně zvolený produkt.
// Viz doc/plans/group-product-filters.md.
import { useState } from 'react'
import { ModalOverlay } from '../ModalOverlay'

function TriStateCheckbox({ state, onClick, title }) {
  return (
    <button
      type="button"
      title={title}
      onClick={onClick}
      className={`w-4 h-4 shrink-0 rounded border flex items-center justify-center text-[10px] leading-none font-bold ${
        state === 'all'
          ? 'bg-blue-500 border-blue-500 text-white'
          : state === 'some'
            ? 'bg-blue-100 border-blue-400 text-blue-600'
            : 'bg-white border-gray-300 text-transparent'
      }`}
    >
      {state === 'all' ? '✓' : state === 'some' ? '−' : '·'}
    </button>
  )
}

export function SaveProductFilterModal({ groupProducts, activeProduct, onSave, onClose }) {
  const allSlugs = groupProducts.flatMap(g => g.items.map(item => item.slug))
  const [selected, setSelected] = useState(activeProduct ? [activeProduct] : [])
  const [pending, setPending] = useState(false)
  const [error, setError] = useState(null)

  const toggle = (slug) => {
    setSelected(sel => sel.includes(slug) ? sel.filter(s => s !== slug) : [...sel, slug])
  }

  const allState = selected.length === 0 ? 'none' : selected.length === allSlugs.length ? 'all' : 'some'
  const toggleAll = () => setSelected(allState === 'all' ? [] : allSlugs)

  async function handleSubmit(e) {
    e.preventDefault()
    if (selected.length === 0) {
      setError('Zvolte alespoň jeden produkt.')
      return
    }
    setPending(true)
    setError(null)
    try {
      await onSave(selected)
      onClose()
    } catch (err) {
      setError(err.message)
    } finally {
      setPending(false)
    }
  }

  return (
    <ModalOverlay onClose={onClose} className="z-50">
      <div className="bg-white rounded-2xl shadow-xl p-6 w-full max-w-sm flex flex-col gap-4">
        <h2 className="text-lg font-bold text-gray-800">Uložit filtr k produktu</h2>

        <form onSubmit={handleSubmit} className="flex flex-col gap-3">
          <div className="flex items-center gap-2 pb-1 border-b border-gray-200">
            <TriStateCheckbox state={allState} onClick={toggleAll} title="Zatrhni vše / Odtrhni vše" />
            <span className="text-xs text-gray-500">Zatrhni vše / Odtrhni vše</span>
          </div>

          <div className="flex flex-col gap-2 max-h-72 overflow-y-auto">
            {groupProducts.map(g => (
              <div key={g.group}>
                <div className="text-xs font-semibold text-gray-500 uppercase mb-1">{g.group}</div>
                <div className="flex flex-col gap-0.5">
                  {g.items.map(item => (
                    <label key={item.slug} className="flex items-center gap-2 text-sm cursor-pointer hover:bg-gray-50 px-1 rounded">
                      <input
                        type="checkbox"
                        checked={selected.includes(item.slug)}
                        onChange={() => toggle(item.slug)}
                        className="accent-blue-500"
                      />
                      {item.label}
                    </label>
                  ))}
                </div>
              </div>
            ))}
          </div>

          {error && (
            <p className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-lg px-3 py-2">{error}</p>
          )}

          <div className="flex gap-3 justify-end pt-1">
            <button type="button" onClick={onClose}
              className="px-4 py-2 text-sm rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50 transition-colors">
              Zrušit
            </button>
            <button type="submit" disabled={pending}
              className="px-4 py-2 text-sm rounded-lg bg-blue-600 text-white font-semibold hover:bg-blue-700 disabled:opacity-50 transition-colors">
              Uložit
            </button>
          </div>
        </form>
      </div>
    </ModalOverlay>
  )
}
